import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "innerClassName", "forceScrollbar", "enableScrollToTop", "banner", "navigation", "bottomBar", "bottomBarHeight", "children"];
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/fp/debounce';
import classNames from 'classnames';
var RESIZE_THROTTELING = 200;
export var ApplicationLayoutBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    innerClassName = props.innerClassName,
    forceScrollbar = props.forceScrollbar,
    enableScrollToTop = props.enableScrollToTop,
    banner = props.banner,
    navigation = props.navigation,
    bottomBar = props.bottomBar,
    bottomBarHeight = props.bottomBarHeight,
    children = props.children,
    remainigProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    offset = _useState2[0],
    setOffset = _useState2[1];
  var moduleContentRef = useRef();
  var layoutBodyRef = useRef();
  useImperativeHandle(ref, function () {
    return layoutBodyRef;
  }, []);
  useEffect(function () {
    if (layoutBodyRef.current) {
      layoutBodyRef.current.parentNode.style = "--ApplicationLayoutBodyBottomBarHeight: ".concat(bottomBarHeight, "px");
    }
  }, [bottomBarHeight]);
  var handleScroll = debounce(RESIZE_THROTTELING)(function () {
    if (moduleContentRef.current) {
      setOffset(moduleContentRef.current.scrollTop);
    }
  });
  var handleToTop = function handleToTop() {
    if (!moduleContentRef.current) {
      return;
    }
    var currentScroll = moduleContentRef.current.scrollTop;
    if (currentScroll > 0) {
      window.requestAnimationFrame(handleToTop);
      moduleContentRef.current.scrollTo(0, currentScroll - currentScroll / 5);
      setOffset(currentScroll);
    }
  };
  var classes = classNames('ApplicationLayoutBody', bottomBar && 'has-footer', className);
  var innerClasses = classNames('module-content', forceScrollbar && 'overflow-y-scroll', innerClassName && innerClassName);
  var offsetThreshold = window.innerHeight * 0.1;
  var scrollToTopClasses = classNames('scroll-to-top', offset > offsetThreshold && 'in');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, remainigProps, {
    ref: layoutBodyRef,
    className: classes
  }), /*#__PURE__*/React.createElement("div", {
    className: "module-content-wrapper"
  }, navigation && navigation, banner && banner, /*#__PURE__*/React.createElement("div", {
    className: innerClasses,
    onScroll: handleScroll,
    ref: moduleContentRef
  }, children)), enableScrollToTop && /*#__PURE__*/React.createElement("span", {
    className: scrollToTopClasses
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary btn-icon-only",
    onClick: handleToTop
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-arrow-up"
  })))), bottomBar && bottomBar);
});
ApplicationLayoutBody.defaultProps = {
  className: '',
  enableScrollToTop: true,
  forceScrollbar: false,
  bottomBarHeight: 54
};
ApplicationLayoutBody.propTypes = {
  className: PropTypes.string,
  enableScrollToTop: PropTypes.bool,
  forceScrollbar: PropTypes.bool,
  innerClassName: PropTypes.string,
  banner: PropTypes.node,
  navigation: PropTypes.node,
  bottomBar: PropTypes.node,
  bottomBarHeight: PropTypes.number
};
export default ApplicationLayoutBody;